import React, { Component } from "react";
import { Col, Container, Row, Badge } from 'reactstrap';

import { withRouter, } from "react-router-dom";
import ModalsVentasPage from "../registrosPage/modals.ventas.page";
import '../rhPage/tabla.css'
import Select from 'react-select'
import moment from 'moment'
import TimeAgo from 'react-timeago'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'

const customStylesOption = { control: styles => ({ ...styles, backgroundColor: '#fff', width: '90%', margin: '0 auto', marginBottom: 20, }), }
const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };
const formatter = buildFormatter(spanishStrings)

class InventariosMermaPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mostrarMisVentas: false,
      arrStock: [],
      fecha_inicio: moment().format('YYYY-MM-DD'),
      fecha_fin: moment().format('YYYY-MM-DD'),

      valSeach: '',

      arrSection: [
        {opt: 'inventario_sucursal', nombre: 'INVENTARIOS', label: 'INVENTARIOS', value: 'INVENTARIOS', },
        {opt: 'entradas', nombre: 'ENTRADAS AL ALMACEN', label: 'ENTRADAS AL ALMACEN', value: 'ENTRADAS AL ALMACEN', },
        {opt: 'ventas', nombre: 'VENTAS / SALIDA DE PRODUCTO', label: 'VENTAS / SALIDA DE PRODUCTO', value: 'VENTAS / SALIDA DE PRODUCTO', },
        // {opt: 'inventario', nombre: 'INVENTARIOS', label: 'INVENTARIOS', value: 'INVENTARIOS', },
      ],

      arrSucursales: [
        {id_sucursal: '5f206899a20c8', nombre: 'INGENIO', label: 'INGENIO', value: 'INGENIO', },
        {id_sucursal: '5f2067c915291', nombre: 'BELLAVISTA', label: 'BELLAVISTA', value: 'BELLAVISTA', },
        {id_sucursal: '5f2071cb03380', nombre: 'ECOCENTRAL', label: 'ECOCENTRAL', value: 'ECOCENTRAL', },
        // {id_sucursal: '5f2071cb0ww32', nombre: 'RUTA', label: 'RUTA', value: 'RUTA', },
        {id_sucursal: '5f2073022efb6', nombre: 'MADERO', label: 'MADERO', value: 'MADERO', },
        // {id_sucursal: 'almacen', nombre: 'ALMACEN', label: 'ALMACEN', value: 'ALMACEN', },
        {id_sucursal: '5f2067c914482', nombre: 'GMART', label: 'GMART', value: 'GMART', },
        {id_sucursal: 'madero2', nombre: 'MADERO 2', label: 'MADERO 2', value: 'MADERO 2', },
      ],

      modalsByInventarios: true,
      indexCategoria: -1,
      indexProducto: -1,
      cantidadFisica: '',
      id_sucursal_option: '5f206899a20c8',
      optSection: 'inventario_sucursal',
      typeView: 'unitario',

      arrHistoryEntradaAlmacen: { index: -1, list: [], productos: [], },
    }
  }

  componentDidMount() {
    this.getStockAlmacen()
  }

  componentWillUnmount() {
  }


  render() {
    const { mostrarMisVentas } = this.state

    return (
      <div style={{ padding: 10, background: '#fff', margin: 0, }}>
        { this.makeViewVentas() }
      </div>
    )
  }

  makeViewVentas() {
    let { arrStock, arrSection, arrSucursales, typeView, optSection, showAll, } = this.state

    return (
      <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', marginTop: 0, }}>
        {/* Principal Container */}
        <Row style={{ width: '99%', margin: '0 auto' }}>
          <Col className={'z-depth-1'} style={{ background: '#fff', }}>
            <Row><p className="regVentaPage__product" style={{ padding: '0 5px', fontWeight: '400', margin: 5, color: '#444', textAlign: 'center', width: '100%', }}>Mermas por productos</p></Row>
            <Row>
              {/*<Col>
                <Select
                  placeholder="INVENTARIOS"
                  options={arrSection}
                  onChange={(val) => { this.setState({optSection: val.opt}, this.getStockAlmacen) }}
                  styles={customStylesOption}
                />
              </Col>*/}
              <Col>
                <Select
                  placeholder="INGENIO"
                  options={arrSucursales}
                  onChange={(val) => { this.setState({id_sucursal_option: val.id_sucursal}, this.getStockAlmacen) }}
                  styles={customStylesOption}
                />
              </Col>
              <Col>
                <Row>
                  <Col>
                    <p>Inicio</p>
                    <input
                      type={'date'}
                      value={ this.state.fecha_inicio }
                      onChange={(e) => { this.setState({ fecha_inicio: e.target.value, arrStock: [], }) }}
                      className={'regVentaPage__input_date'}
                    />
                  </Col>
                  <Col>
                    <p>Fin</p>
                    <input
                      type={'date'}
                      value={ this.state.fecha_fin }
                      onChange={(e) => { this.setState({ fecha_fin: e.target.value, arrStock: [], }) }}
                      className={'regVentaPage__input_date'}
                    />
                  </Col>
                  <Col>
                    <p className={'btn btn-primary'} style={{ }} onClick={() => { this.getStockAlmacen() }}>Generar</p>
                  </Col>
                  <Col>
                    <p className={'btn btn-primary'} style={{ }} onClick={() => { this.setState({ showAll: !showAll }, this.getStockAlmacen) }}>{ !showAll ? 'Ver todos' : 'Ver solo registrados' }</p>
                  </Col>
                  {/*<Col>
                    <p className={'btn btn-secondary'} onClick={() => { this.setState({ typeView: typeView === 'unitario' ? 'total' : 'unitario' }) }}>Ver: {typeView === 'unitario' ? 'P. Unitario' : 'P. Total'}</p>
                  </Col>*/}
                </Row>
              </Col>
            </Row>

            { /* arrStock.length === 0 ? (
                <div className="loadScreen">
                  <img src={'img/hgapp/loading.gif'} alt="loading"/>
                  <p>No se encontraron productos en esta fecha</p>
                </div>
              ) : null*/ }

            { optSection === 'entradas'   ? this.makeEntradasVerify()    : null }
            { optSection === 'ventas'     ? this.makeVentasVerify()      : null }
            { optSection === 'inventario' ? this.makeInventarioVerify()  : null }
            { optSection === 'inventario_sucursal' ? this.makeInventarioSucursalVerify()  : null }

            { arrStock.length > 0 ? <button onClick={() => { this.setSendEmailInventarioEnd() }} className={'btn btn-primary'}>Finalizar inventario</button> : null }
          </Col>
        </Row>

        <ModalsVentasPage
          subState={ this.state } subSetState={ (param) => this.setState(param) }
          onMarkEnd={ (param) => { this.onMarkEnd(param) } }
        />

      </div>
    )
  }

  makeEntradasVerify() {
    let { arrHistoryEntradaAlmacen, } = this.state

    return (
      <>
      {
        arrHistoryEntradaAlmacen.index > -1 ? (
          <>
            <p onClick={() => { arrHistoryEntradaAlmacen.index = -1; this.setState({arrHistoryEntradaAlmacen }) }} style={{ cursor: 'pointer', }}>Regresar</p>
            <Row className={'ventasPage__listProductos'}>
              <Col xs={6}><b>Producto</b></Col>
              <Col xs={2}><p>Cantidad</p></Col>
              <Col xs={2}><p>Costo de compra registrado</p></Col>
              <Col xs={2}><p>Estatus</p></Col>
            </Row>
            {
              arrHistoryEntradaAlmacen.productos.map((t,e) => (
                <Row className={'ventasPage__listProductos'}>
                  <Col xs={6}><b>{t.nombre}</b></Col>
                  <Col xs={2}><p>{ t.cantidad }</p></Col>
                  <Col xs={2}><p>${ this.number_format(t.costo,2) }</p></Col>
                  <Col xs={2}>
                    
                    { t.verify === 0 ? (<>
                      <button style={{ cursor: 'pointer', }} className={'btn btn-primary'}>Autorizar</button>
                      <button style={{ cursor: 'pointer', }} className={'btn btn-danger'}>No autorizar</button>
                    </>) : null }
                    { t.verify === 1 ? (<>
                      <Badge color={'success'}>Autorizado</Badge>
                    </>) : null }
                    { t.verify === 2 ? (<>
                      <Badge color={'danger'}>No autorizado</Badge>
                    </>) : null }
                  </Col>
                </Row>
              ))
            }
          </>
        ) : arrHistoryEntradaAlmacen.list.map((t,e) => (
          <Row className={'ventasPage__listProductos'}>
            <Col xs={6}><b>{t.referencia}</b></Col>
            <Col xs={2}><p>{ moment(t.created_at).format('DD/MM/YYYY H:mm:ss') }</p></Col>
            <Col>
              <button
                style={{ marginLeft: 5, marginBottom: 4, width: '100%', }}
                className={'btn btn-secondary'}
                onClick={ () => { arrHistoryEntradaAlmacen.index = e; this.setState({ arrHistoryEntradaAlmacen }); this.getProductosByEntradaAlmacen() }}
              >Ver productos</button>
            </Col>
          </Row>
        ))
      }
      </>
    )
  }

  makeVentasVerify() {
    let { arrStock, valSeach, typeView, } = this.state
    valSeach = valSeach.trim()

    return (
      <>
      {
      arrStock.length > 0 && arrStock.map((t,e) => (
        <>
        {
          t.list.length > 0 ? (
            <div className={'ws__list_categorias_almacen'}>
              <Row className={`ws__list_categorias_almacen_p ${t.show ? 'active' : ''}`} onClick={() => { this.onExpandSectionCate(t,e) }}>
                <Col><p>{t.nombre}</p></Col>
                <Col><p style={{ fontSize: '.8rem', textAlign: 'right', }}>({this.number_format(t.list.length, 0)}) productos</p></Col>
              </Row>
              {
                t.show ? (
                  <div className={'ws__searchcnt'}>
                    <p>Buscar</p>
                    <input type={'text'} onChange={ (event) => { this.setState({ valSeach: event.target.value }) } } placeholder={'Buscar un producto...'} />
                  </div>
                ) : null
              }

              {
                t.show ? (
                <Row>
                  <Col xs={'8'}><b>Producto</b></Col>
                  <Col><b>Cantidad inicial</b></Col>
                  <Col><b>Cantidad vendida</b></Col>
                  <Col><b>Cantidad cierre</b></Col>
                  <Col><b>Acciones</b></Col>
                </Row>
                ) : null
              }

              {
                t.show && t.list.map((t0,e0) => (
                  <>
                  {
                    valSeach === '' || 
                    t0.clave && t0.clave.toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ||
                    t0.nombre && t0.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ? (
                    <Row className={'ventasPage__listProductos ws__list_categorias_almacen_child'} style={{ marginTop: 20, marginBottom: 20, }}>
                      <Col xs={'8'}>
                        <p>{t0.nombre}</p>
                        {this.makeInfoType(t0.validado_inventario, t0)}
                      </Col>
                      <Col><p>{this.number_format(t0.cantidad_vendida + t0.disponible, 2)}</p></Col>
                      <Col><p>{this.number_format(t0.cantidad_vendida, 2)}</p></Col>
                      <Col><p>{this.number_format(t0.disponible, 2)}</p></Col>
                      <Col><p onClick={() => { this.makeModalConfirmCantidad(e, e0, t0.disponible) }}>Validar</p></Col>
                    </Row>
                    ) : null
                  }
                  </>
                ))
              }
            </div>
          ) : null
        }
        </>
      ))
    }
      </>
    )
  }

  makeInventarioVerify() {
    let { arrStock, valSeach, typeView, } = this.state
    valSeach = valSeach.trim()

    return (
      <>
      {
      arrStock.length > 0 && arrStock.map((t,e) => (
        <>
        {
          t.list.length > 0 ? (
            <div className={'ws__list_categorias_almacen'}>
              <Row className={`ws__list_categorias_almacen_p ${t.show ? 'active' : ''}`} onClick={() => { this.onExpandSectionCate(t,e) }}>
                <Col><p>{t.nombre}</p></Col>
                <Col><p style={{ fontSize: '.8rem', textAlign: 'right', }}>({this.number_format(t.list.length, 0)}) productos</p></Col>
              </Row>
              {
                t.show ? (
                  <div className={'ws__searchcnt'}>
                    <p>Buscar</p>
                    <input type={'text'} onChange={ (event) => { this.setState({ valSeach: event.target.value }) } } placeholder={'Buscar un producto...'} />
                  </div>
                ) : null
              }

              {
                t.show ? (
                <Row>
                  <Col xs={'6'}><b>Nombre</b></Col>
                  <Col xs={'2'}><b>Existencia</b></Col>
                  <Col xs={'2'}><b>Compra</b></Col>
                  <Col xs={'2'}><b>Venta</b></Col>
                </Row>
                ) : null
              }

              {
                t.show && t.list.map((t0,e0) => (
                  <>
                  {
                    valSeach === '' || 
                    t0.clave && t0.clave.toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ||
                    t0.nombre && t0.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ? (
                    <Row onClick={() => { this.makeModalConfirmCantidad(e, e0, t0.disponible) }} className={'ventasPage__listProductos ws__list_categorias_almacen_child'} style={{ marginTop: 20, marginBottom: 20, }}>
                      <Col xs={'6'}>
                        <p>{t0.nombre}</p>
                        {this.makeInfoType(t0.validado_inventario, t0)}
                      </Col>
                      <Col xs={'2'}><p>{this.number_format(t0.disponible, 2)}</p></Col>
                      <Col xs={'2'}><p>${this.number_format( typeView === 'unitario' ? t0.precio_compra : t0.disponible * t0.precio_compra, 2)}</p></Col>
                      <Col xs={'2'}><p>${this.number_format( typeView === 'unitario' ? t0.precio_venta: t0.disponible * t0.precio_venta , 2)}</p></Col>
                    </Row>
                    ) : null
                  }
                  </>
                ))
              }
            </div>
          ) : null
        }
        </>
      ))
    }
      </>
    )
  }

  makeInventarioSucursalVerify() {
    let { arrStock, valSeach, typeView, fecha_inicio, fecha_fin } = this.state
    valSeach = valSeach.trim()

    const diffDays = moment(fecha_fin).diff(moment(fecha_inicio), 'days') + 1


    return (
      <>
        <div className={'ws__searchcnt'}>
          <p>Buscar</p>
          <input type={'text'} onChange={ (event) => { this.setState({ valSeach: event.target.value }) } } placeholder={'Buscar un producto...'} />
          <hr />
        </div>

        <div className="table-responsive">
          <table className="table table-sm table-striped mt-2">
            <thead>
              <tr>
                <td>Nombre</td>
                <td style={{ background: '#6a89cc', textAlign: 'center', }}>Merma acumulada por fechas</td>
                <td style={{ background: '#6a89cc', textAlign: 'center', }}>Cantidad promedio diario</td>

                <td style={{ background: '#78e08f', textAlign: 'center', }}>Costo de compra</td>
                <td style={{ background: '#78e08f', textAlign: 'center', }}>Total perdido</td>

                <td style={{ background: '#1abc9c', textAlign: 'center', }}>Existencia reportada cajero</td>
{/*
                <td style={{ background: '#1abc9c', textAlign: 'center', }}>Costo de venta</td>
                <td style={{ background: '#1abc9c', textAlign: 'center', }}>Total pasivo</td>
                */}
              </tr>
            </thead>
            <tbody>
              {
                arrStock.length > 0 && arrStock.map((t,e) => { 
                  if(valSeach === '' || 
                    t.clave && t.clave.toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ||
                    t.nombre && t.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1) {
                    let entrada_ayer = (t.cantidad_entrada_historico - t.cantidad_entrada_hoy),
                    movimientos_historicos = ( t.cantidad_vendida_historico + t.cantidad_traspaso_historico + t.cantidad_merma_historico ),
                    movimientos_hoy = ( t.cantidad_vendida_hoy + t.cantidad_traspaso_hoy + t.cantidad_merma_hoy ),
                    movimientos_ayer = ( movimientos_historicos - movimientos_hoy )

                    return (
                      <tr key={`invent-id-${t.id_producto}`}>
                        <td style={{ paddingTop: 25,  }}>
                          <p style={{ width: 300, fontSize: '1.2rem', margin: 0, }}>{t.nombre}</p>
                          <p style={{ width: 300, fontSize: '1.2rem', margin: 0, }}><b>{t.clave}</b></p>
                        </td>
                        <td style={{ paddingTop: 25, background: '#6a89cc', }}>
                          <p style={{ textAlign: 'center', fontSize: '1.3rem', }}><b>{ this.number_format( t.cantidad_cajero_confirmada, 2 ) }</b></p>
                        </td>
                        <td style={{ paddingTop: 25, background: '#6a89cc', }}>
                          <p style={{ textAlign: 'center', fontSize: '1.3rem', position: 'relative', }}> 
                            <b>{ this.number_format(t.cantidad_cajero_confirmada / diffDays, 2) }</b>
                          </p>
                        </td>
                        <td style={{ paddingTop: 25, background: '#78e08f', }}>
                          <p style={{ textAlign: 'center', fontSize: '1.3rem', position: 'relative', }}>${this.number_format(t.precio_compra, 2)}</p>
                        </td>
                        
                        <td style={{ paddingTop: 25, background: '#78e08f', }}>
                          <p style={{ textAlign: 'center', fontSize: '1.3rem', }}><b>${ this.number_format(t.precio_compra * t.cantidad_cajero_confirmada, 2) }</b></p>
                        </td>

                        <td style={{ paddingTop: 25, background: '#1abc9c', }}>
                          <p style={{ textAlign: 'center', fontSize: '1.3rem', }}><b>{ this.number_format(t.cantidad_cajero_hoy, 2) }</b></p>
                        </td>
{/*
                        <td style={{ paddingTop: 25, background: '#1abc9c', }}>
                          <p style={{ textAlign: 'center', fontSize: '1.3rem', }}><b>${ this.number_format(t.precio_venta, 2) }</b></p>
                        </td>

                        <td style={{ paddingTop: 25, background: '#1abc9c', }}>
                          <p style={{ textAlign: 'center', fontSize: '1.3rem', }}><b>${ this.number_format(t.precio_venta * t.cantidad_cajero_hoy, 2) }</b></p>
                        </td>
*/}
                      </tr>
                    )
                  }
                })
              }
            </tbody>
          </table>
        </div>

      </>
    )
  }

  //Opción de eliminar registro equivocado
  onDeleteRegistroCajero(t, e) {
    let { arrStock, } = this.state,
    data = { id_inventario: t.id_inventario, id_producto: t.id_producto, }

    if(window.confirm(`¿Estás seguro que eliminar el registro ${t.nombre} creado por el cajero?.`)) {

      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setDeleteRegistroInventario", this.headersPOST(data))
      .then(response => response.json())
      .then((response) => {
        arrStock[e].id_inventario = null;
        arrStock[e].cantidad_cajero_mostrada = 0;
        this.setState({ arrStock, })
      })
    }

  }

  onResetRegistroCajero(t, e) {
    let { arrStock, } = this.state,
    data = { ...t, }

    if(window.confirm(`¿Estás seguro que deseas ajustar la existencia de ${t.nombre} por la del cajero?\nESTA ACCIÓN NO SE PUEDE REVERTIR.`)) {

      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setResetRegistroInventario", this.headersPOST(data))
      .then(response => response.json())
      .then((response) => {
        arrStock[e].cantidad_merma_historico = t.diferencia * -1
        arrStock[e].cantidad_cajero_confirmada = 1
        this.setState({ arrStock, })
      })
    }

  }

  makeInfoType(opt, item) {
    if(opt === 1) {
      return <Badge style={{'background':'#f39c12', color: '#fff', }} variant="success">Sin verificar</Badge>
    } else if(opt === 2) {
      return <Badge style={{'background':'#2ecc71', color: '#fff', }} variant="success">Verificado</Badge>
    } else if(opt === 3) {
      return <Badge style={{'background':'#c0392b', color: '#fff', }} variant="success">Diferencia de {this.number_format(item.cantidad_mostrada - item.cantidad_confirmada, 2)} KG</Badge>
    }
  }

  onMarkEnd(opt) {
    let { arrStock, indexCategoria, indexProducto, cantidadFisica, id_sucursal_option, } = this.state
    const { id_producto, nombre, clave, disponible, } = arrStock[indexCategoria].list[indexProducto]


    const data = {
      id_producto,
      disponible,
      cantidadFisica,
      id_sucursal: id_sucursal_option,
      id_usuario: this.props.initState.signedIn.id_usuario,
      opt,
    }
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterInventario", this.headersPOST(data))
    .then(response => response.json())
    .then((response) => {
      arrStock[indexCategoria].list[indexProducto].cantidad_mostrada = disponible
      arrStock[indexCategoria].list[indexProducto].cantidad_confirmada = cantidadFisica
      arrStock[indexCategoria].list[indexProducto].created_at = (new Date())
      arrStock[indexCategoria].list[indexProducto].validado_inventario =
      ( arrStock[indexCategoria].list[indexProducto].cantidad_mostrada == 0 && arrStock[indexCategoria].list[indexProducto].cantidad_confirmada == 0) ? 1
      : (arrStock[indexCategoria].list[indexProducto].cantidad_mostrada == arrStock[indexCategoria].list[indexProducto].cantidad_confirmada ? 2 : 3 );

      this.setState({
        isOpenConfirmInfoProducto: false,
        indexCategoria: -1,
        indexProducto: -1,
        cantidadFisica: '',
        arrStock,
      })
    })

  }

  setSendEmailInventarioEnd() {
    const { id_sucursal } = this.props.initState
    let { id_sucursal_option, fecha_inicio, } = this.state
    id_sucursal_option = id_sucursal_option === '' ? id_sucursal : id_sucursal_option
    
    const data = {
      fecha_inicio,
      id_sucursal: id_sucursal_option,
      id_usuario: this.props.initState.signedIn.id_usuario,
    }
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setSendEmailInventarioEnd", this.headersPOST(data))
    .then(response => response.json())
    .then((response) => {
      alert('Inventario notificado de finalizado.')
    })

  }

  makeModalConfirmCantidad(e, e0, disponible) {
    this.setState({ isOpenConfirmInfoProducto: true, indexCategoria: e, indexProducto: e0, cantidadFisica: disponible, })
  }

  makeModalConfirmCantidadVerify(e, disponible) {
    this.setState({ isOpenConfirmInfoProducto: true, indexCategoria: -2, indexProducto: e, cantidadFisica: disponible, })
  }

  onExpandSectionCate(t,e) {
    let { arrStock, } = this.state
    for(var a in arrStock) {
      if(a != e)
        arrStock[a].show = false
      else
      arrStock[a].show = !arrStock[a].show
    }
    this.setState({ arrStock, valSeach: '', })
  }

  getStockAlmacen() {
    this.setState({
      arrStock: [],
    })

    let { id_sucursal_option, fecha_inicio, fecha_fin, optSection, } = this.state

    if(optSection === 'entradas') {
      this.getHistoryEntradas()
      return false
    }

    const { id_sucursal, } = this.props.initState
    id_sucursal_option = id_sucursal_option === '' ? id_sucursal : id_sucursal_option

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getMovimientosMermasByDateInventario", this.headersPOST({ v: 2, id_sucursal: id_sucursal_option, fecha_inicio, fecha_fin, optSection, showAll: this.state.showAll, }))
    .then(response => response.json())
    .then((response) => {
      this.setState({ arrStock: response, })
    })
  }

  getHistoryEntradas() {
    let { id_sucursal_option, fecha_inicio, } = this.state
    const { id_sucursal } = this.props.initState
    id_sucursal_option = id_sucursal_option === '' ? id_sucursal : id_sucursal_option
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getHistoryEntradas", this.headersPOST({ id_sucursal: id_sucursal_option, date: fecha_inicio }))
    .then(response => response.json())
    .then((response) => {
      this.setState({ arrHistoryEntradaAlmacen: {index: -1, list: response.list, productos: [], }, })
    })
  }

  getProductosByEntradaAlmacen() {
    let { arrHistoryEntradaAlmacen } = this.state
    let { index, list, } = arrHistoryEntradaAlmacen
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getProductosByEntradaAlmacen", this.headersPOST({ id_entrada: list[ index ].id_entrada, }))
    .then(response => response.json())
    .then((response) => {
      arrHistoryEntradaAlmacen.productos = response.list
      this.setState({ arrHistoryEntradaAlmacen, })
    }).catch((error) => console.info(error));
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }


}

export default withRouter(InventariosMermaPage)





